import { GetServerSideProps } from 'next';
import { useContext, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { PacksContext } from '@/components/app/layout/PacksProvider';
import Layout from '@/components/layout/LayoutWrapper';
import SearchBar from '@/components/SearchBar';
import { InitRequest, useInitState } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const messages = defineMessages({
	title: {
		id: 'app.components.screenTitle.searchHeading',
		defaultMessage: 'Search',
		description: 'The title of the page where users can search for content',
	},
});

const Search = () => {
	useInitState({ requests: [InitRequest.USER, InitRequest.DEVICE] });
	const { formatMessage } = useIntl();
	const { setPageTitle } = useContext(PacksContext);

	useEffect(() => {
		setPageTitle(formatMessage(messages.title));
	}, [setPageTitle, formatMessage]);

	return (
		<Layout pageName="search">
			<SearchBar />
		</Layout>
	);
};

export default Search;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context, [InitRequest.DEVICE, InitRequest.USER]);

	return {
		props: {
			appHeaderProps: {
				pageTitle: messages.title,
			},
			initialState: {
				...initialState,
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
